import {useSearchClient} from './use-search';
import {CategorieWeb} from 'api-types/ffconnect';

export function useCategorieWeb(cat_web_id: string): CategorieWeb | undefined {
  const {getNomenclatureWeb} = useSearchClient();
  const nomenclatureWeb = getNomenclatureWeb();
  return nomenclatureWeb?.find((cat) => cat.id === cat_web_id);
}
